import {
  V2ReplaySubmissionResponseSchema,
  V2ReplaySubmissionSchema,
} from "@repo/shared";

import {functionHookFactoryV2} from "../factories/functionHookFactory";

export const submitReplayV2 = functionHookFactoryV2(
  "submitReplayV2",
  V2ReplaySubmissionSchema,
  V2ReplaySubmissionResponseSchema,
);
